import React from "react";

/**
 * SideRail alternative to AppShell's built-in side rail. Use when you need
 * the rail without the app shell (rare in R1a).
 */
export function SideRail({ items = [], brand }) {
  return (
    <aside className="ds-shell-side">
      {brand}
      {items.map((n) => (
        <div
          key={n.key}
          className={`ds-shell-item ${n.active ? "is-active" : ""}`.trim()}
          onClick={n.onClick}
          role="button"
          tabIndex={0}
        >
          {n.icon}{n.label}
          {n.badge && <span className="badge">{n.badge}</span>}
        </div>
      ))}
    </aside>
  );
}
